
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/building/[...slug]",
      function () {
        return require("private-next-pages/building/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/building/[...slug]"])
      });
    }
  